/**
 * Component to render cell with a typedValue of type STORABLE_PLACEHOLDERS.
 */
import React from 'react';

import StorableChip from 'inventory/chips/StorableChip';
import {
  formatStorablePlaceholdersTypedValue,
  FormattedStorableGroup,
} from 'notebook/tables/typed-values/storables/StorablePlaceholdersTypedValue';
import {StorablePlaceholdersTypedValue} from 'notebook/tables/typed-values/TypedValueTypes';
import {ChipSize} from 'ui-library/chips/Chip';

const StorablePlaceholdersTableCellSegment: React.FunctionComponent<
  StorablePlaceholdersTableCellSegmentProps
> = ({formattedStorableGroup}) => {
  if (formattedStorableGroup.type === 'NEW_STORABLES') {
    return <span className="placeholderText">{`${formattedStorableGroup.count} new`}</span>;
  } else {
    const {id} = formattedStorableGroup.storableSummary;
    return <StorableChip className="tableCell-multiChip" id={id} size={ChipSize.TABLE_CELL} />;
  }
};

interface StorablePlaceholdersTableCellSegmentProps {
  formattedStorableGroup: FormattedStorableGroup;
}

const StorablePlaceholdersTableCell: React.FunctionComponent<StorablePlaceholdersTableCellProps> = ({
  typedValue,
}) => {
  const intermediateFormat = formatStorablePlaceholdersTypedValue(typedValue);
  return (
    <span>
      {intermediateFormat.map((formattedStorableGroup, i) => (
        <StorablePlaceholdersTableCellSegment key={i} formattedStorableGroup={formattedStorableGroup} />
      ))}
    </span>
  );
};

interface StorablePlaceholdersTableCellProps {
  typedValue: StorablePlaceholdersTypedValue;
}

export default StorablePlaceholdersTableCell;
